import styled from 'styled-components';

interface matchEndedProps {
  noOfButtons?: number;
}

export default styled.div<matchEndedProps>`
  text-align: center;
  font-size: 18px;
  flex: 1;
  align-items: center;
  display: block;

  .header {
    display: block;
  }

  .buttons {
    display: flex;
    justify-content: center;
    .actions {
      display: grid;
      grid-template-columns: ${(props) =>
        props.noOfButtons === 3 ? '1fr 1fr 1fr' : props.noOfButtons === 2 ? '1fr 1fr' : '1fr'};
      grid-gap: 25px;
      flex-direction: column;
      align-items: center;

      button {
        white-space: nowrap;
      }
    }
  }
`;
